import PurchaseOrderDetailsContainer from "@legacy/purchase_orders/PurchaseOrderDetailsContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { PURCHASE_ORDER_ROUTES } from "@routes/purchase-orders"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function PurchaseOrderDetails() {
    const [listRoute] = useSlugExtractor([PURCHASE_ORDER_ROUTES.LIST])
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const backDestination = hasPermission("purchase_orders_list_permission", PERMISSION_LEVEL.FULL)
        ? listRoute
        : undefined

    return (
        <AppFrame.Root pageId="PurchaseOrderDetails" navigationType="inner">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageInnerTitle label="Purchase Order Details" backDestination={backDestination} />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <PurchaseOrderDetailsContainer addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
